import type { ISEOProps } from "../types/core";

export const ReferralPageSEO: ISEOProps = {
  title: "Referral Program | Sugar Cribs",
  description:
    "Invite your friends and earn up to $400! Share a link to receive $10 for each registered friend on Sugar Cribs.",
};
